import { redirect, Form } from 'react-router-dom';
import {
    QueryClient,
} from 'react-query';

import {
    createUser
} from 'api/user/user';
import { UserCreateRequest } from 'api/models';

import {
    useGetAllLanguages,

} from "api/language/language"

export const action = (queryClient: QueryClient) =>
    async ({ request }: any) => {
        const formData = await request.formData();
        const updates = Object.fromEntries(formData);
        // Get multiple value
        updates.languageIds = formData.getAll('languageIds');
        await createUser(updates as UserCreateRequest);
        return redirect('../');
    };

function UserCreator() {

    const { data: languages } = useGetAllLanguages();

    return (
        <div>
            <Form
                className="flex flex-col max-w-md mx-auto"
                method="post" id="update-user">
                <label
                    className="mt-8 text-gray-500"
                    htmlFor="firstName"
                >
                    First name
                    <input
                        autoFocus
                        placeholder="First"
                        aria-label="First name"
                        type="text"
                        className="w-full px-4 py-2 mt-2 text-lg font-semibold border-2 border-gray-400 rounded-md"
                        name="firstName"
                    />
                </label>
                <label
                    className="mt-8 text-gray-500"
                    htmlFor="lastName"
                >
                    Last name
                    <input
                        placeholder="Last"
                        aria-label="Last name"
                        type="text"
                        className="w-full px-4 py-2 mt-2 text-lg font-semibold border-2 border-gray-400 rounded-md"
                        name="lastName"
                    />
                </label>

                <label
                    className="mt-8 text-gray-500"
                    htmlFor="password"
                >
                    Password
                    <input
                        placeholder="Password"
                        aria-label="Password"
                        className="w-full px-4 py-2 mt-2 text-lg font-semibold border-2 border-gray-400 rounded-md"
                        type="password"
                        name="password"
                    />

                </label>
                <label
                    className="mt-8 text-gray-500"
                    htmlFor="email"
                >
                    Email address
                    <input
                        placeholder="Email"
                        aria-label="Email"
                        className="w-full px-4 py-2 mt-2 text-lg font-semibold border-2 border-gray-400 rounded-md"
                        type="email"
                        name="email"
                    />

                </label>

                <label
                    className="mt-8 text-gray-500"
                    htmlFor="mobileNumber"
                >
                    Mobile number
                    <input
                        placeholder="Mobile"
                        aria-label="Mobile"
                        className="w-full px-4 py-2 mt-2 text-lg font-semibold border-2 border-gray-400 rounded-md"
                        type="phone"
                        name="mobileNumber"
                    />
                </label>
                {languages?.data.map((language, index) => (
                    <div key={index} className="my-2">
                        <label>
                            <input
                                className="ml-2"
                                name="languageIds"
                                id={language.id}
                                type="checkbox"
                                value={language.id}
                                // Add your handling function for checkbox state
                                // onChange={handleCheckboxChange}
                            />
                            <span className="ml-2">{language.name}</span>
                        </label>
                    </div>
                ))}   

                <button
                    className="inline-flex items-center px-6 py-3 mt-6 text-base font-medium text-center text-white bg-orange-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    type="submit">Save</button>
            </Form>
        </div>
    );
}

export default UserCreator;